/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _ConsultationEditionFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable ember/no-runloop */
import Store from "@ember-data/store";
import { next } from "@ember/runloop";
import { service } from "@ember/service";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import CrudJournalEventBasedComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import ConsultationPlannedJournalEvent from "core/models/consultation-planned-journal-event";
import Creator from "core/models/creator";
import MedicModel from "core/models/medic";
import Patient from "core/models/patient";
import ConfigurationService, { Configuration } from "core/services/configuration";
import SemeiaSessionService from "core/services/session";
import { ValidatorMap } from "ember-changeset/types";
import { IntlService } from "ember-intl";
import computeConsultationTypeId, { ConsultationType } from "../utils/compute-consultation-type-id";
let ConsultationEditionFormComponent = (_class = (_ConsultationEditionFormComponent = class ConsultationEditionFormComponent extends CrudJournalEventBasedComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "configuration", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
  }
  get hideTitle() {
    return this.args.hideTitle;
  }
  get validations() {
    return this.journalEventClass.validations(this.intl);
  }
  get forcDisplayName() {
    return this.hideTitle ? "" : super.forcDisplayName;
  }

  /**
   * This represents a type of consultation.
   * It regroups a procedure and a provider.
   */
  get consultationTypes() {
    const map = new Map();
    const consultationAllowedTypes = (this.configuration.configurationForPatient(Configuration.Consultation, this.args.patient).consultationAllowedTypes || []).filter(consultationType => consultationType.enabled);
    consultationAllowedTypes.forEach(consultationType => map.set(computeConsultationTypeId(consultationType), this._verifyConsultationType(consultationType)));
    return map;
  }

  /**
   * Get all the ConsultationType defined in the configuration files
   * and transform them into ComputedConsultationType by generating ids.
   */
  get computedConsultationTypes() {
    return Array.from(this.consultationTypes).map(([id, consultationType]) => ({
      key: id,
      label: consultationType.procedure.sourceLabel
    }));
  }
  get model() {
    next(this, this.initChangeset);
    // eslint-disable-next-line parog-web/no-use-of-model-in-crud-forc
    return super.model;
  }
  initChangeset() {
    if (this.isNewMode) {
      if (this.computedConsultationTypes.length == 1) {
        this.changeset.consultationTypeId = this.computedConsultationTypes[0].key;
      }
    } else {
      this.changeset.consultationTypeId = computeConsultationTypeId(this.changeset);
    }
    if (this.isNewMode && !this.changeset.responsible) {
      this.changeset.responsible = this.session.medic;
    }
    return this.changeset;
  }
  beforeValidation() {
    const consultationType = this.consultationTypes.get(this.changeset.consultationTypeId);
    if (!consultationType) {
      throw new Error(`Impossible to save the 'consultation-planned-journal-event' because there is no consultation type corresponding to the id '${this.changeset.consultationTypeId}'.`);
    }
    this.changeset.set("procedure", consultationType.procedure);
    this.changeset.set("provider", consultationType.provider);
  }
  async save() {
    const je = await super.save();
    if (this.args.patient.therapeuticalArea?.id == "onco" && this.args.patient.healthCentre?.isgt) {
      await this.store.query("treatment-history-changed-journal-event", {
        filter: {
          patient_id: this.args.patient.id
        }
      });
    }
    if (je.treatmentHistoryChangedJournalEvent) {
      await je.treatmentHistoryChangedJournalEvent.clearAndFetchAssociatedTaskAndConsultation();
    }
    return je;
  }

  /**
   * This method set the missing values if there is,
   * like the source-concept for the procedure and the provider for example.
   * And throw errors if there is missing values.
   */
  _verifyConsultationType(consultationType) {
    const provider = consultationType.provider;
    provider.specialtySourceConcept = provider.specialtySourceConcept || "SPE";
    if (!provider.specialtySourceValue) {
      throw new Error(`The following provider is missing a 'specialtySourceValue': ${provider}`);
    }
    if (!provider.specialtySourceLabel) {
      throw new Error(`The following provider is missing a 'specialtySourceLabel': ${provider}`);
    }
    const procedure = consultationType.procedure;
    procedure.sourceConcept = procedure.sourceConcept || "SEMEIA";
    if (!procedure.sourceValue) {
      throw new Error(`The following procedure is missing a 'sourceValue': ${procedure}`);
    }
    if (!procedure.sourceLabel) {
      throw new Error(`The following procedure is missing a 'sourceLabel': ${procedure}`);
    }
    return {
      procedure,
      provider
    };
  }
  onChange(responsible) {
    this.changeset.set("responsible", responsible);
  }
  get responsible() {
    return this.changeset.get("responsible")?.content || this.changeset.get("responsible");
  }
}, _defineProperty(_ConsultationEditionFormComponent, "fullComponentId", "consultation/edition-form"), _defineProperty(_ConsultationEditionFormComponent, "forcDisplayName", "Rendez-vous"), _defineProperty(_ConsultationEditionFormComponent, "journalEventClass", ConsultationPlannedJournalEvent), _ConsultationEditionFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "configuration", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ConsultationEditionFormComponent as default };